import config from '../../data/config'

const en = {
    Home:{
        title: 'Your Personal Portal To the World',
        subtitle: 'Collect your bookmarks and Create your personal portal to the world',
        purpose: 'What this site for',
        purpose1: 'You can collect your bookmarks using bookmarklet and create your personal portal to the world',
        purpose2: 'You can create, edit and delete your bookmarks, even set the nice background image for page',
        purpose3: 'You can rearrange your bookmarks by drag-and-drop',
        purpose4: 'You can create several pages and set the page as public or private( default)',
        purpose5: 'You can share your bookmarks with others',
        purpose6: 'You can use \'anonym\' userid without signup or You can use your own userid if signup (free)',
        purpose7: 'Good News. All are free.',
        contact: 'Contact Us',
        signup: 'Free Signup',
        contactName: 'neohompy',
        contactEmail: 'neohompy@gmail.com',
        card1:{
            image: '/img/1-300x200.jpg',
            title: 'Userid \'anonym\'',
            descr1: 'You can use this site without signup',
            descr2: 'In this case, all your bookmarks are stored in your local computer',
            descr3: 'If you want to use your bookmarks in your other device, please signup. It is free',
            more: 'Find Out More!',
            moreUrl: '',
        },
        card2:{
            image: '/img/2-300x200.jpg',
            title: 'Your Own Userid',
            descr1: 'You can have your own userid when signup',
            descr2: 'In this case, your bookmarks are saved at server.',
            descr3: 'You can use your bookmarks across all your devicesIf. It is free',
            more: 'Find Out More!',
            moreUrl: '',
        },
        card3:{
            image: '/img/3-300x200.jpg',
            title: 'Bookmarklet',
            descr1: 'You can collect your bookmarks using bookmarklet',
            descr2: 'Bookmarklet is on the heaader of this home page.',
            descr3: 'Drag and drop the bookmarklet onto the bookmarkbar of your browser.',
            more: 'Find Out More!',
            moreUrl: '',
        },
        card4:{
            image: '/img/4-300x200.jpg',
            title: 'Import existing bookmarks',
            descr1: 'You can import your existing bookmarks by way of HTML format.',
            descr2: 'First, export your existing bookmarks from your webbrowser as a HTML file.',
            descr3: 'Second, import the above exported HTML file. This adds a new page.',
            more: 'Find Out More!',
            moreUrl: '',
        },
        card5:{
            image: '/img/5-300x200.jpg',
            title: 'Drag and Drop',
            descr1: 'You can drag and drop a category, book or bookmarks(links) by title.',
            descr2: 'If you drop item on the title of target, the dragged item becomes a child (or sibling) of the target.',
            descr3: 'If you drop item on the icon of target, the dragged item becomes a sibling (or child) of the target.',
            more: 'Find Out More!',
            moreUrl: '',
        },
        card6:{
            image: '/img/6-300x200.jpg',
            title: 'Public and Private Page',
            descr1: 'You can set the page as Public and Private ( default ).',
            descr2: 'If private, others can not access your private page.',
            descr3: 'You can set each book as public to share with others.',
            more: 'Find Out More!',
            moreUrl: '',
        },
    },
    share:{
        mainTitle: 'Share your wonderful link books.',
        humanSelected: 'These shared link books are human-selected and human-managed.',
        embedInto: 'Individual book can be copied to your page or embeded into yout website.',
        url1: 'The book url is https://neohompy.com/share/BookTitle',
        example1: 'for example: ',
        exampleUrl1: 'https://neohompy.com/share/izone',
        url2: 'Or the book url is https://neohompy.com/share/SearchWord',
        example2: 'for example: ',
        exampleUrl2: 'https://neohompy.com/share/k-pop',
        embedCode: 'Full embeded code is :',
        recentBooks: 'Recent Books',
        moreRecentBooks: 'more of Recent Books',
        end: 'end',
        searchResult: 'Search Result',
        moreSearchResult: 'more of Search Result',
    },
    Footer:{
        copyright: 'Copyright',
        company: 'neohompy 2020',
    },
   header:{
       name: 'English',
       company: 'neohompy',
       home: 'Home',
       share: 'Share',
       myhome: 'Myhome',
       signup: 'Signup',
       signout: 'Signout',
       login: 'Login',
       logout: 'Logout',
       account: 'Account',
       bookmarklet: 'Bookmarklet',
   },
   PageList:{
       newpage: '+ New Page',
       public: 'public',
       private: 'private',
   },
   page:{
       public: 'PUBLIC',
       private: 'PRIVATE',
       pge: 'page',
       auth_error: 'Editing is NOT authorized.',
       moveItemError: 'Parent Item CANNOT move to Child Item',
       moveItemChildError: 'Parent Item CANNOT move under Child Item',
   },

   HeaderMyhome:{
       memoShown: 'Shown',
       memoHidden: 'Hidden',
       tidy1: 'As is',
       tidy2: 'Tidy',
       tidy3: 'See',
       bookmarklet: 'Bookmarklet',
   },
   Search: {
       searchHolder: 'Search',
       search: 'Search',
   },
   SearchResult: {
        SearchResults: 'SearchResults',
        NoSearchResults: 'No Results',
   },
   loginmodal:{
       login: 'Login',
       signup: 'Signup',
       email: 'Email',
       emailholder: 'enter a valid email',
       emailguide: 'example@example.com',
       requestcode_label: 'Verify Email',
       requestcode: 'Request Code for Email Verification',
       requestcode_guide: '',
       verifycode_holder: 'Enter Code sent to Email',
       verifycode: 'Send Code',
       notverified_error: 'Email is not verified',
       userid: 'Userid',
       useridholder: 'enter a userid',
       useridguide: 'Must be '+config.userid_min + '-' + config.userid_max + ' characters long.',
       userid_lower_error: 'Must be lowercase.',
       userid_min_error: 'Must be longer than '+ config.userid_min,
       userid_max_error: 'Must be shorter than ' + config.userid_max,
       userid_required_error: 'Userid is required',
       pass: 'Password',
       passholder: 'enter a password',
       passguide: 'Must be '+config.pass_min + '-' + config.pass_max + ' characters long.',
       pass_min_error: 'Must be longer than '+ config.pass_min,
       pass_max_error: 'Must be shorter than ' + config.pass_max,
       pass2: 'Password2',
       passholder2: 'enter same password',
       passguide2: 'Type the same password again.',
       pass_match_error: 'Must be same password.',
       close: 'Close',
       submit: 'Submit',
       title_min_error:'Title is too short.',
       title_max_error:'Title is too long.',
       title_required_error: 'title is required',
       url_error:'Url is not valid.',
       url_max_error:'Url is too long.',
       bgurl_max_error:'Url is too long.',
       email_error:'Email is not valid.',
       email_max_error:'Email is too long.',
       email_required_error:'Email is required',
       pass_mismatch_error:'Password does not match.',
       pass_required_error:'Password is required.',
       token_error: 'Token is not valid',
       token_min_error:'token is too short.',
       token_max_error:'token is too long.',
       pass_change_msg: 'Password has changed.',
       pass_change_error: 'Change password has problem.',
       pass_wrong_error: 'userid or password is not correct!',
       server_error: 'server has problem.',
       unique_error: 'Userid is not unique',

   },
   logoutmodal:{
       logout: 'Logout',
       logoutConfirm: 'Are you going to logout? You can come back again.',
       logoutBtn: 'Confirm',
       closeBtn: 'Cancel',
       signout: 'Signout',
       signoutConfirm: 'Are you going to signout? All data will be erased.',
       signoutBtn: 'Confirm',
       signoutTab: 'Signout',
       newpassTab: 'Change Password',
       newpassTitle: 'Change Password',
       userid: 'Userid',
       useridguide: 'Current userid',
       pass: 'Password',
       passguide: 'Current password',
       newpass: 'New Password',
       newpassholder: 'enter New Password',
       newpassConfirm: 'To change password, enter an CURRENT and NEW password below.',
       newpassguide: 'Must be '+config.pass_min + '-' + config.pass_max + ' characters long.',
       newpassBtn: 'Confirm',
   },
   mymodal:{
       type:{
           pge: 'Page',
           fld: 'Category',
           bok: 'Book',
           lnk: 'Link'
       },
        edt:{
           title: 'Edit',
           tab: 'Edit'
        },
        fld:{
            title: 'New Category',
            tab: 'Category'
        },
        bok:{
            title: 'New Book',
            tab: 'Book'
        },
        lnk:{
            title: 'New Link',
            tab: 'Link'
        },
        pge: {
            title: 'New Page',
            tab: 'Page'
        },
        form:{
            kind: 'Kind',
            child: 'Child',
            sibling: 'Sibling',
            sharing: 'Share',
            share: 'share',
            notshare: 'NOT share',
            privacy: 'Privacy',
            public: 'public',
            private: 'private',
            defaulting: 'Default',
            default: 'default',
            notdefault: 'NOT default',
            title: 'Title',
            titleHolder: 'enter Title',
            href: 'URL',
            hrefHolder: 'enter URL (option)',
            bgurl: 'Bg URL',
            bgurlHolder: 'enter Background URL (option)',
            memo: 'Memo',
            memoHolder: 'enter Memo (option)',
            keywords: 'Key Words',
            keywordsHolder: 'enter Key Words (option)',
            smallBg: 'Small_Image',
            smallBgHolder: 'enter Small Image URL',
            largeBg: 'Large_Image',
            largeBgHolder: 'enter Large Image URL',
            bgColor: 'Bg Color',
            bgColorHolder: 'Bg Color',
            color: 'Color',
            colorHolder: 'Color',
            icon: 'Icon URL',
            iconHolder: 'Icon URL',
            title_min_error: 'title is too short',
            title_max_error: 'title is too long',
            unique_error: 'title is not unique',
            url_error: 'url is not valid',
            url_max_error: 'url is too long',
            memo_min_error: 'memo is too short',
            memo_max_error: 'memo is too long',
            bgurl_max_error: 'bgurl is too long',
        },
        share: 'Share',
        unshare: 'UnShare',
        shared: 'Shared item',
        unshared: 'Unshared item',
        confirmshare: 'Share this item?',
        confirmunshare: 'UnShare this item?',
        saveCloseState: 'Keep State',
        copy: 'Copy',
        cut: 'Cut',
        paste: 'Paste',
        close: 'Close',
        submit: 'Save',
        delete: 'Delete',
        quickdelete: 'Delete',
        create_error: 'cannot create a category or book under link',
        paste_error: 'cannot paste a category or book under link',
        auth_error: 'You are NOT authorized',
        pageCopy_error: 'Page cannot be copied',
        pageCut_error: 'Page cannot be cut',
        clearpaste: 'Clear Paste',
        clearnewlink: 'Clear Link',
        setAsDefault: 'Set as Default Page',
        isDefault: 'Default Page',
   },
   mymodalshare:{
       copyquestion:'Copy this item?',
       type:{
        pge: 'Page',
        fld:'Category',
        bok: 'Book',
        lnk: 'Link'
       },
       copy: 'Copy',
       copyguide: 'You copied an item. Paste it or cancel it',
       cancelcopy: 'Cancel Copy',
       close: 'Close',
       cannotcopy: 'Page cannot be copied.',
       copywidget: 'Copy this code and paste it into your html.',
       copyurl: 'If you want any other search word, replace "YourWord" or search with your own word.',
       companyurl: 'https://neohompy.com/share',
       companyname: 'neohompy',
   },
   expo:{
      tabImport: 'Impo',
      tabExport: 'Expo',
      tabRecover: 'Reco',
      tabClear: 'Clear',
      tabTheme: 'Theme',
      tabBgimg: 'Bg',
      tabTools: 'Tools',
      title:{
         tabImport: 'Import Bookmarks( HTML or JSON )',
         tabExport: 'Export Bookmarks HTML',
         tabRecover: 'Recover default Bookmarks',
         tabClear: 'Clear Local Storage',
         tabTheme: 'Theme',
         tabBgimg: 'Background Image',
         tabTools: 'Tools',
      },
      bodyImport: {
          html: 'your HTML file to import',
          json: 'your JSON file to import ( Recommended )',
          default: 'This imports default page',
          defaultBtn: 'default page',
      },
      bodyExport: {
          body1: 'This saves ( exports ) your bookmarks as HTML file or JSON file.',
          body2: 'Choose HTML file to import to other web browsers.',
          btn1: 'save as HTML file',
          btn2: 'save as JSON file (recommended)',
      },
      bodyRecover: {
          body1: 'You can signup Userid and Password instantly and use it for temporary backup or recovery of your bookmarks.',
          userid: 'Userid',
          useridHolder: 'enter userid...',
          password: 'Password',
          passwordHolder: 'enter password...',
          btn1: 'Backup to Server',
          btn2: 'Recover from Server',
          foot1: 'Your current myhome will be replaced with the recovery from server or default bookmarks.',
      },
      bodyClear: {
          body1:'This clears your local storage.',
          body2:' All bookmarks will be removed from local storage.',
          body3:'So be sure to ',
          body4:'save (export) your bookmarks as HTML before clearing',
          body5:' the local storage.',
          body6:'Default bookmarks will be set after clearing the local storage.',
          btn1:'Clear Local Storage',
      },
      bodyTheme: {
          body1: 'Theme. The default theme is \'cosmo\'.',
          dropdown1: 'Choose Theme',
      },
      bodyBgImage: {
          body1: 'Background Images.',
          dropdown1: 'Choose Background Image',
      },
      bodyTools: {
          body1: 'Following process is applied to arrange the bookmarks.',
          body2: 'Try the process you want.',
          body3: 'The result will ',
          body4: 'not be saved',
          body5: ' until you click the save button.',
          body6: 'Initial number: ',
          body7: ' Final number: ',
          body8: ' Deleted number: ',
          btn1: 'Remove duplicate Links',
          btn2: 'Remove empty folders',
          btn3: 'Sort Folders',
          btn4: 'Sort Folders (Reverse)',
          btn5: 'Restore Sort',
          btn6: 'Flatten the category',
      },
      footBtn1: 'Recover Default Bookmarks',
      footBtn2: 'Close',
      footBtn3: 'Save theme',
      footBtn4: 'Save Bg Image',
      footBtn5: 'Save the result',
      mockPageData: {
        type: "pge",
        key: "home",
        title: "home",
        close: false,
        default: false,
        children: [
          {
            children: [
              {
                type: "bok",
                key: "5z7F5TIaH2",
                title: "Temp",
              },
            ],
            type: "fld",
            key: "5z7F5TIaH3",
            title: "Temp",
          },
          {
            children: [
              {
                type: "bok",
                key: "d9RyT4vpy4",
                title: "Daily",
              },
              {
                type: "bok",
                key: "d9RyT4vpy1",
                title: "Email",
              },
              {
                type: "bok",
                key: "d9RyT4vpy3",
                title: "Search",
              },
            ],
            type: "fld",
            key: "d9RyT4vpy0",
            title: "Daily",
          },
          {
            children: [
              {
                type: "bok",
                key: "dyGdiLYg32",
                title: "News",
              },
              {
                type: "bok",
                key: "kgae9aqCc0",
                title: "Science",
              },
            ],
            type: "fld",
            key: "d9RyT4vpy6",
            title: "News",
          },
          {
            children: [
              {
                type: "bok",
                key: "Xju6PbN7o1",
                title: "Social",
              },
            ],
            type: "fld",
            key: "d9RyT4vpy8",
            title: "Social",
          },
          {
            children: [
              {
                type: "bok",
                key: "pU12o0gLg5",
                title: "Shopping",
              },
            ],
            type: "fld",
            key: "pU12o0gLg4",
            title: "Shopping",
          },
          {
            children: [
              {
                type: "bok",
                key: "5z7F5TIaH1",
                title: "Business",
              },
              {
                type: "bok",
                key: "kgae9aqCc4",
                title: "Real Estate",
              },
              {
                type: "bok",
                key: "kgae9aqCc3",
                title: "Finance",
              },
            ],
            type: "fld",
            key: "kgae9aqCc2",
            title: "Business",
          },
          {
            children: [
              {
                type: "bok",
                key: "dyGdiLYg35",
                title: "Game",
              },
              {
                type: "bok",
                key: "dyGdiLYg34",
                title: "Video",
              },
              {
                type: "bok",
                key: "dyGdiLYg33",
                title: "Music",
              },
            ],
            type: "fld",
            key: "d9RyT4vpy7",
            title: "Entertainment",
          },
          {
            children: [
              {
                type: "bok",
                key: "iLSYvK3DA0",
                title: "Lifestyle",
              },
              {
                type: "bok",
                key: "RR8SEXtEw0",
                title: "Food",
              },
              {
                type: "bok",
                key: "Xju6PbN7o0",
                title: "Health",
              },
            ],
            type: "fld",
            key: "JGfJ_gc3L0",
            title: "Lifestyle",
          },
          {
            children: [
              {
                type: "bok",
                key: "pU12o0gLg1",
                title: "Hobby",
              },
              {
                type: "bok",
                key: "pU12o0gLg3",
                title: "Arts",
              },
              {
                type: "bok",
                key: "pU12o0gLg2",
                title: "Travel",
              },
            ],
            type: "fld",
            key: "rkmMsW9V10",
            title: "Hobby",
          },
        ],
      },
      mockPageList: [
        {
          type: "pge",
          key: "home",
          title: "home",
        },
      ],
      shortPageData: {
        "type": "pge",
        "key": "home",
        "title": "home",
        "close": false,
        "default": false,
        "children": [
          {
            "children": [
              {
                "type": "bok",
                "key": "d9RyT4vpy4",
                "title": "book",
                "children": [
                  {
                    "children": [
                      {
                        "type": "lnk",
                        "key": "I4FxYgS3056",
                        "title": "link"
                      }
                    ],
                    "type": "lnk",
                    "key": "I4FxYgS3034",
                    "title": "link"
                  }
                ],
              }
            ],
            "type": "fld",
            "key": "d9RyT4vpy0",
            "title": "category"
          }
        ]
      }
  },
}

export default en;